import React, { useState, useRef, useEffect } from 'react';
import CreatableSelect from 'react-select/creatable';
import { FaInfoCircle } from 'react-icons/fa';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import {
  getDataDB,
  saveDataDB, ld,
  isImageField
} from "../api";
import moment from "moment";





const Tooltip = ({ text }) => (
  <span style={{ position: 'relative', marginLeft: 5, display: 'inline-block' }}
    onMouseEnter={e => e.currentTarget.querySelector('.tooltip-text').style.visibility = 'visible'}
    onMouseLeave={e => e.currentTarget.querySelector('.tooltip-text').style.visibility = 'hidden'}>
    <FaInfoCircle style={{ cursor: 'pointer' }} />
    <span className="tooltip-text" style={{
      visibility: 'hidden',
      backgroundColor: 'black',
      color: '#fff',
      textAlign: 'center',
      padding: '5px',
      borderRadius: '4px',
      position: 'absolute',
      zIndex: 9999,
      bottom: '125%',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '220px',
      whiteSpace: 'normal'
    }}>{text}</span>
  </span>
);


export default function RecipeCalculator() {
  const [companyName, setCompanyName] = useState(null);
  const [recipeTitle, setRecipeTitle] = useState(null);
  const [yieldDesc, setYieldDesc] = useState(null);
  const [ingredientName, setIngredientName] = useState(null);
  const [ingredients, setIngredients] = useState([]);
  const [allIngredients, setAllIngredients] = useState([]);

  const [ingredientOptions, setIngredientOptions] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [recipeOptions, setRecipeOptions] = useState([]);

  const [ingredientInput, setIngredientInput] = useState({ cost: '', units: '', pounds: '', qtyUsed: '', qtyUnit: 'lb', brand: '', supplier: '' });
  const [expectedYieldQty, setExpectedYieldQty] = useState('');
  const [expectedYieldUnit, setExpectedYieldUnit] = useState('servings');
  const [packagingCost, setPackagingCost] = useState('');
  const [hours, setHours] = useState(1);

  // ✅ New fields for Mfg cost calculation
  const [dailyOverhead, setDailyOverhead] = useState(3000);
  const [numEmployees, setNumEmployees] = useState(7);
  const [hoursPerDay, setHoursPerDay] = useState(8);
  const [loading, setLoading] = useState(false);


  const addIngredient = () => {
    const { cost, units, pounds, qtyUsed, qtyUnit } = ingredientInput;
    if (!ingredientName?.label || !cost || !units || !pounds || !qtyUsed) return;
    const costPerUnit = parseFloat(cost) / parseFloat(units);
    const costPerLb = parseFloat(cost) / parseFloat(pounds);
    const qtyUsedLb = parseFloat(qtyUsed) * (unitToPound[qtyUnit] || 1);
    const priceForRecipe = costPerLb * qtyUsedLb;
    const newItem = {
      name: ingredientName.label, ...ingredientInput, costPerUnit, costPerLb, qtyUsedLb, priceForRecipe,
    };
    setIngredients([...ingredients, newItem]);
    setIngredientInput({ cost: '', units: '', pounds: '', qtyUsed: '', qtyUnit: 'lb', brand: '', supplier: '' });
    setIngredientName(null);
  };
  const printRef = useRef();

  const totalPrice = ingredients.reduce((sum, item) => sum + item.priceForRecipe, 0);
  const totalWeight = ingredients.reduce((sum, item) => sum + item.qtyUsedLb, 0);
  const foodCost = expectedYieldQty > 0 ? totalPrice / expectedYieldQty : 0;

  // ✅ Updated Mfg cost formula
  const mfgCost = ((dailyOverhead / numEmployees / hoursPerDay) * hours) || 0;

  const finalCost = foodCost + parseFloat(packagingCost || 0) + mfgCost;

  const handlePrint = () => {
    const printContent = printRef.current;
    const win = window.open('', '', 'width=900,height=700');
    win.document.write('<html><head><title>Recipe Invoice</title>');
    win.document.write('<style>body { font-family: sans-serif; padding: 20px; } h1, h2 { color: #004080; } table { width: 100%; border-collapse: collapse; margin-top: 20px; } th, td { border: 1px solid #ccc; padding: 8px; text-align: left; } th { background-color: #f0f0f0; } .summary { margin-top: 20px; } .summary div { margin-bottom: 8px; }</style>');
    win.document.write('</head><body>');
    win.document.write(printContent.innerHTML);
    win.document.write('</body></html>');
    win.document.close();
    win.focus();
    win.print();
    win.close();
  };


  const handleExportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(ingredients);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Ingredients");
    XLSX.writeFile(wb, "recipe-ingredients.xlsx");
  };

  const handleSave = () => {
    setLoading(true)
    const blob = new Blob([JSON.stringify({ companyName, recipeTitle, ingredients }, null, 2)], { type: 'application/json' });
    // alert(JSON.stringify({ companyName, recipeTitle, ingredients }))
    if (!recipeTitle?.value) {
      alert('Missing results')
      return
    }
    saveDataDB({
      query: {
        date: moment(),
        companyName,
        title: recipeTitle?.value,
        ingredients,
      },
      keys: ["title"],
      resource: "vare_recipe_calc",
    }).then((info) => {
      alert('Saved')
      setLoading(false)

    });

  };

  const fieldGroupStyle = { display: 'flex', flexDirection: 'column', minWidth: '150px', flex: '1' };
  const gridStyle = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '10px', marginBottom: '20px' };

  useEffect(() => {

    getDataDB({
      query: {
        titless: null,
      },
      resource: "vare_recipe_calc",
    }).then((info) => {
      console.log('kkkkk', info)
      setAllIngredients(info)
      // setAllIngredients(info);

      const all = info.flatMap(r => r.ingredients || []);
      const ingredientNames = Array.from(new Set(all.map(i => i.name))).map(name => ({ label: name, value: name }));
      const companies = Array.from(new Set(info.map(r => r.companyName?.value || r.companyName?.label || ''))).map(n => ({ label: n, value: n }));
      const recipes = info.map(r => ({ label: r.title, value: r.title }));

      setIngredientOptions(ingredientNames);
      setCompanyOptions(companies);
      setRecipeOptions(recipes);
    });
  }, [
    recipeTitle?.value
  ])


  return (
    <div style={{ padding: 20, maxWidth: 1200, margin: 'auto' }}>
      <h2>Recipe Calculator</h2>
      {loading ? <div>Loading...</div> : <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
        <button onClick={handleSave}>💾 Save</button>
        <button onClick={handlePrint}>🖨️ Print</button>
        <button onClick={handleExportToExcel}>📥 Export to Excel</button>
      </div>}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 20, marginBottom: 20 }}>
        <div style={fieldGroupStyle}>
          <label>Company Name<Tooltip text="Select or add the company name" /></label>
          <CreatableSelect value={companyName} onChange={setCompanyName} options={companyOptions} placeholder="Select or add company" />
        </div>
        <div style={fieldGroupStyle}>
          <label>Recipe Title<Tooltip text="Select or add the recipe title" /></label>
          <CreatableSelect value={recipeTitle} onChange={setRecipeTitle} options={recipeOptions} placeholder="Select or add recipe" />
        </div>
      </div>

      <div style={{
        paddingBottom: 20
      }}>
        <RecipeIngredients />
      </div>


      <h3>Summary</h3>
      <div style={gridStyle}>
        <div style={fieldGroupStyle}>
          <label>Expected Yield Qty<Tooltip text="Total servings, pieces, or lbs expected" /></label>
          <input type="number" value={expectedYieldQty} onChange={(e) => setExpectedYieldQty(e.target.value)} />
        </div>
        <div style={fieldGroupStyle}>
          <label>Expected Yield Unit<Tooltip text="Unit for yield (servings, pieces, lbs)" /></label>
          <select value={expectedYieldUnit} onChange={(e) => setExpectedYieldUnit(e.target.value)}>
            <option>servings</option><option>pieces</option><option>lbs</option>
          </select>
        </div>
        <div style={fieldGroupStyle}>
          <label>Yield Description<Tooltip text="Container type or description" /></label>
          <CreatableSelect value={yieldDesc} onChange={setYieldDesc} placeholder="Add container type" />
        </div>
        <div style={fieldGroupStyle}>
          <label>Packaging Cost<Tooltip text="Total packaging cost in $" /></label>
          <input type="number" value={packagingCost} onChange={(e) => setPackagingCost(e.target.value)} />
        </div>
        <div style={fieldGroupStyle}>
          <label>Hours<Tooltip text="Hours for manufacturing cost calculation" /></label>
          <select value={hours} onChange={(e) => setHours(Number(e.target.value))}>
            {[1, 2, 3, 4, 5, 6, 7, 8].map(h => <option key={h}>{h}</option>)}
          </select>
        </div>

        {/* ✅ New Mfg-related fields */}
        <div style={fieldGroupStyle}>
          <label>Daily Overhead ($)<Tooltip text="Total daily overhead cost for the facility" /></label>
          <input
            type="number"
            value={dailyOverhead}
            onChange={(e) => setDailyOverhead(Number(e.target.value))}
          />
        </div>
        <div style={fieldGroupStyle}>
          <label># of Employees<Tooltip text="Number of employees working per day" /></label>
          <input
            type="number"
            value={numEmployees}
            onChange={(e) => setNumEmployees(Number(e.target.value))}
          />
        </div>
        <div style={fieldGroupStyle}>
          <label>Hours per Day<Tooltip text="Typical full workday hours" /></label>
          <input
            type="number"
            value={hoursPerDay}
            onChange={(e) => setHoursPerDay(Number(e.target.value))}
          />
        </div>
      </div>

      <h3>Cost Summary</h3>
      <div>
        <strong>Total Ingredient Weight Used (lb)<Tooltip text="Sum of all Qty/Weight converted to lb" /></strong>: {totalWeight.toFixed(2)} lb
      </div>
      <div>
        <strong>Total Ingredient Cost<Tooltip text="Sum of all Price for Recipe" /></strong>: ${totalPrice.toFixed(2)}
      </div>
      <div>
        <strong>Food Cost (Per Yield)<Tooltip text="Total Ingredient Cost ÷ Expected Yield Qty" /></strong>: ${foodCost.toFixed(2)}
      </div>
      <div>
        <strong>Packaging Cost<Tooltip text="Packaging cost entered above" /></strong>: ${parseFloat(packagingCost || 0).toFixed(2)}
      </div>
      <div>
        <strong>Mfg Cost<Tooltip text="(Daily Overhead ÷ # of Employees ÷ Hours per Day) × Hours worked" /></strong>: ${mfgCost.toFixed(2)}
      </div>
      <div>
        <strong>Final Total Cost<Tooltip text="Food + Packaging + Mfg Cost" /></strong>: ${finalCost.toFixed(2)}
      </div>
    </div>
  );
}

const unitToPound = {
  lb: 1,
  kg: 2.20462,
  g: 0.00220462,
  oz: 0.0625,
  liter: 2.20462,
  ml: 0.00220462,
  gal: 8.34,
  cups: 0.5216,
};
const RecipeIngredients = () => {
  const [ingredientName, setIngredientName] = useState(null);
  const [ingredientOptions, setIngredientOptions] = useState([]);
  const [ingredientInput, setIngredientInput] = useState({
    brand: '',
    supplier: '',
    cost: '',
    units: '',
    pounds: '',
    costPerUnit: '',
    costPerPound: '',
    batchWeight: '',
    price: '',
    qtyUsed: '',
    qtyUnit: 'lb',
    weightMetric: 'lb',
    weightValue: '', // <-- NEW
  });


  const [ingredients, setIngredients] = useState([]);
  const [autoConvertPounds, setAutoConvertPounds] = useState(true);

  // Auto-calculate costPerUnit, costPerPound, price
  useEffect(() => {
    const cost = parseFloat(ingredientInput.cost || 0);
    const units = parseFloat(ingredientInput.units || 0);
    const pounds = parseFloat(ingredientInput.pounds || 0);
    const batchWeight = parseFloat(ingredientInput.batchWeight || 0);

    const costPerUnit = units ? cost / units : 0;
    const costPerPound = pounds ? cost / pounds : 0;
    const price = costPerPound * batchWeight;

    setIngredientInput(prev => ({
      ...prev,
      costPerUnit: costPerUnit.toFixed(2),
      costPerPound: costPerPound.toFixed(2),
      price: price.toFixed(2),
    }));
  }, [ingredientInput.cost, ingredientInput.units, ingredientInput.pounds, ingredientInput.batchWeight]);

  useEffect(() => {
    if (!autoConvertPounds) return;

    const value = parseFloat(ingredientInput.weightValue || 0);
    const unit = ingredientInput.weightMetric || 'lb';
    const pounds = value * (unitToPound[unit] || 1);

    setIngredientInput((prev) => ({
      ...prev,
      pounds: pounds.toFixed(2),
    }));
  }, [ingredientInput.weightValue, ingredientInput.weightMetric, autoConvertPounds]);


  const addIngredient = () => {
    const {
      cost, units, pounds, qtyUsed, qtyUnit, costPerUnit, costPerPound, batchWeight, price
    } = ingredientInput;

    const newIngredient = {
      name: ingredientName?.label || '',
      brand: ingredientInput.brand,
      supplier: ingredientInput.supplier,
      cost: parseFloat(cost || 0),
      units: parseFloat(units || 0),
      pounds: parseFloat(pounds || 0),
      costPerUnit: parseFloat(costPerUnit || 0),
      costPerLb: parseFloat(costPerPound || 0),
      batchWeight: parseFloat(batchWeight || 0),
      qtyUsed: parseFloat(qtyUsed || 0),
      qtyUnit,
      priceForRecipe: parseFloat(price || 0),
    };

    setIngredients([...ingredients, newIngredient]);

    setIngredientInput({
      brand: '',
      supplier: '',
      cost: '',
      units: '',
      pounds: '',
      costPerUnit: '',
      costPerPound: '',
      batchWeight: '',
      price: '',
      qtyUsed: '',
      qtyUnit: 'lb',
    });

    setIngredientName(null);
  };

  const totalWeight = ingredients.reduce((sum, ing) => {
    const qtyInPounds = ing.qtyUnit === 'lb' ? ing.qtyUsed : ing.qtyUsed * unitToPound[ing.qtyUnit];
    return sum + qtyInPounds;
  }, 0);

  const totalCost = ingredients.reduce((sum, ing) => sum + ing.priceForRecipe, 0);

  return (
    <>
      <h3>Ingredients</h3>
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingBottom: 20
      }}>
        <div style={{ width: '45%' }}>
          <label>Ingredient Name<Tooltip text="Enter or select the ingredient name" /></label>
          <CreatableSelect
            value={ingredientName}
            onChange={setIngredientName}
            options={ingredientOptions}
            placeholder="Enter or select ingredient"
          />
        </div>
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', marginBottom: 20 }}>
        {[
          { label: 'Cost ($)', key: 'cost', type: 'number' },
          { label: 'Units', key: 'units', type: 'number' },
          { label: 'pounds', key: 'pounds', type: 'number' },
          { label: 'Cost / Unit', key: 'costPerUnit', type: 'number', cal: true },
          { label: 'Cost / Lb', key: 'costPerPound', type: 'number', cal: true },
          { label: 'Batch Weight', key: 'batchWeight', type: 'number' },
          { label: 'Price', key: 'price', type: 'text', readOnly: true, cal: true },
        ].map((f) => {


          const sharedProps = {
            type: f.type,
            value: ingredientInput[f.key],
            readOnly: !!f.readOnly || !!f.cal || f.key === 'pounds',
            style: { width: '100%' },
          };

          if (f.key === 'pounds') {
            return (
              <div style={{ flex: '1 1 250px' }}>
                <label>
                  {ingredientInput.weightValue
                    ? `${ingredientInput.weightValue} ${ingredientInput.weightMetric} = ${ingredientInput.pounds} lb`
                    : 'Weight'}
                  <Tooltip text={`Converted from ${ingredientInput.weightMetric}`} />
                </label>
                <input
                  type="number"
                  value={ingredientInput.weightValue}
                  onChange={(e) => {
                    const val = e.target.value;
                    const pounds = parseFloat(val || 0) * (unitToPound[ingredientInput.weightMetric] || 1);
                    setIngredientInput({
                      ...ingredientInput,
                      weightValue: val,
                      pounds: pounds.toFixed(2),
                    });
                  }}
                  style={{ width: '100%' }}
                />

                <label style={{ marginTop: 8 }}>
                  Weight Metric<Tooltip text="Unit used for original weight" />
                </label>
                <select
                  value={ingredientInput.weightMetric}
                  onChange={(e) => {
                    const newMetric = e.target.value;
                    const pounds = parseFloat(ingredientInput.weightValue || 0) * (unitToPound[newMetric] || 1);
                    setIngredientInput({
                      ...ingredientInput,
                      weightMetric: newMetric,
                      pounds: pounds.toFixed(2),
                    });
                  }}
                >
                  {Object.keys(unitToPound).map(u => (
                    <option key={u}>{u}</option>
                  ))}
                </select>
              </div>

            );
          }


          if (!sharedProps.readOnly) {
            sharedProps.onChange = (e) =>
              setIngredientInput({ ...ingredientInput, [f.key]: e.target.value });
          }

          return (
            <div key={f.key} style={{ flex: '1 1 150px' }}>
              <label>{f.label}<Tooltip text={`Input for ${f.label}`} /></label>
              <input {...sharedProps} />
            </div>
          );
        })}


      </div>

      <button onClick={addIngredient} style={{ marginBottom: 20 }}>Add Ingredient</button>

      <div style={{ fontWeight: 'bold', fontSize: '1.2em', marginBottom: 10 }}>
        Units (Yield): 66 — 16oz Containers
      </div>

      <table border="1" cellPadding="5" style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th>Name</th><th>Brand</th><th>Supplier</th><th>Cost</th><th>Units</th><th>Pounds</th>
            <th>Qty / Weight</th><th>Qty Unit</th>
            <th>Cost/Unit</th><th>Cost/Lb</th><th>Price</th>
          </tr>
        </thead>
        <tbody>
          {ingredients.map((item, i) => (
            <tr key={i}>
              <td>{item.name}</td><td>{item.brand}</td><td>{item.supplier}</td>
              <td>${item.cost.toFixed(2)}</td><td>{item.units}</td><td>{item.pounds}</td>
              <td>{item.qtyUsed}</td><td>{item.qtyUnit}</td>
              <td>${item.costPerUnit.toFixed(2)}</td>
              <td>${item.costPerLb.toFixed(2)}</td>
              <td>${item.priceForRecipe.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="9" />
            <td><strong>Total Weight</strong></td>
            <td><strong>{totalWeight.toFixed(2)}</strong></td>
          </tr>
          <tr>
            <td colSpan="9" />
            <td><strong>Food Cost</strong></td>
            <td><strong>${totalCost.toFixed(2)}</strong></td>
          </tr>
        </tfoot>
      </table>
    </>
  );
};


